var staticDayTime = require('./staticDayTime')

var staticWeekTime = staticDayTime * 7

module.exports = staticWeekTime



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticWeekTime.js
// module id = 339
// module chunks = 98